import { createTheme, responsiveFontSizes } from '@mui/material'
import { grey } from '@mui/material/colors'

const themeConfig = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        outlined: {
          '&.MuiButton-outlinedGoogle': {
            textTransform: 'none',
          },
        },
      },
    },
  },
  palette: {
    facebook: {
      contrastText: '#FFF',
      main: '#4267B2',
    },
    google: {
      contrastText: grey[50],
      main: grey[800],
    },
    linkedin: {
      contrastText: '#FFF',
      main: '#0072b1',
    },
    primary: {
      contrastText: '#FAF9F9',
      main: '#1D1E2C',
    },
  },
  typography: {
    button: {
      fontWeight: 700,
    },
    fontFamily: ['Manrope', 'Roboto', '-apple-system', 'sans-serif'].join(','),
    h4: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
    subtitle1: {
      fontWeight: 700,
    },
    subtitle2: {
      fontWeight: 700,
    },
  },
})

const publicTheme = responsiveFontSizes(themeConfig)

export default publicTheme
